import {Base} from "@/api/Base"

export class AttendanceEdit extends Base {
    path = "attendance/edit"
}